import { Box, Button, Flex, Heading, Paragraph } from "@eworkit/iris";
import React, { FC, useContext, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

import { AnimatedLayoutModal } from "@/components/animated-layout";
import { UserContext } from "@/components/User";
import { IConsultantProfile } from "@/data/consultant-profiles";
import { isActive } from "@/data/consultant-profiles/utils/isActive";
import { isBlocked } from "@/data/consultant-profiles/utils/isBlocked";
import { AnimatedLayout } from "@/views/components/Layout";

import { OnboardingProfileTypeSelect } from "../components/ProfileTypeSelect";
import { ConsultantProfileCard } from "../consultant-profiles/ConsultantProfileCard";
import { router } from "../router";

export const OnboardingManageProfile: FC = ({}) => {
  const User = useContext(UserContext);

  const { t } = useTranslation("session");

  const [createAnother, setCreateAnother] = useState(false);

  const activeProfiles = User.sessionUser.consultantProfiles.filter(cp => isActive(cp));
  const inactiveProfiles = User.sessionUser.consultantProfiles
    .filter(cp => !isActive(cp))
    .sort(cp => (isBlocked(cp) ? -1 : 1));

  const handleCreateAnotherClick = () => {
    setCreateAnother(true);
  };

  const handleRequestToJoinSent = () => {
    setCreateAnother(false);
  };

  const handleActiveProfileClick = (profile: IConsultantProfile) => {
    User.setConsultantProfileContext(profile.id);
  };

  return createAnother ? (
    <OnboardingProfileTypeSelect onRequestToJoinSent={handleRequestToJoinSent} />
  ) : (
    <AnimatedLayout>
      <AnimatedLayoutModal>
        <Box px={[null, null, "xxl"]}>
          <Flex flexDirection="column" gap="lg">
            <Heading size="h-lg" align="center">
              {t("ONBOARDING.MANAGE_PROFILE.HEADER")}
            </Heading>

            {inactiveProfiles.length > 0 && (
              <Flex flexDirection="column" gap={["0", null, "xs"]}>
                {inactiveProfiles.map(profile => (
                  <ConsultantProfileCard key={profile.id} profile={profile} />
                ))}
              </Flex>
            )}

            {activeProfiles.length > 0 && (
              <Flex flexDirection="column" gap={["0", null, "xs"]}>
                <Box px={["sm", null, "0"]} pb={["xs", null, "0"]}>
                  <Paragraph color="n700">{t("ONBOARDING.MANAGE_PROFILE.SELECT_ANOTHER_PROFILE")}</Paragraph>
                </Box>

                {activeProfiles.map(profile => (
                  <ConsultantProfileCard
                    key={profile.id}
                    profile={profile}
                    onClick={() => handleActiveProfileClick(profile)}
                  />
                ))}
              </Flex>
            )}

            <Flex
              gap="xs"
              px={["sm", null, "0"]}
              flexDirection={["column-reverse", null, "row"]}
              justifyContent="flex-end">
              <Button as={Link} to={router.get("logout").path} variant="ghost">
                {t("ONBOARDING.REQUESTS_TO_JOIN_LIST.BUTTON_LOG_OUT")}
              </Button>
              <Button variant="secondary" onClick={handleCreateAnotherClick}>
                {t("ONBOARDING.REQUESTS_TO_JOIN_LIST.BUTTON_CREATE_ANOTHER")}
              </Button>
            </Flex>
          </Flex>
        </Box>
      </AnimatedLayoutModal>
    </AnimatedLayout>
  );
};
